<script setup lang="ts">
import { addClass, isContainsClass, isLastLoop, removeClass } from "@TsUtils/helpers";
import { inject, ref }                                        from "vue";
import { type TypeCommonProps }                               from "@ViewPages/Main/Components/commonTypes";

const props = inject<TypeCommonProps>('header_props'),
    menuEl = ref<HTMLElement>(),
    showMenuBtnEl = ref<HTMLButtonElement>(),
    hideMenuBtnEl = ref<HTMLButtonElement>();

const showMenu = () : void => {
    removeClass('-right-full', menuEl.value as HTMLElement);
    addClass('right-0', menuEl.value as HTMLElement);
    addClass('overflow-hidden', document.body);
};

const hideMenu = () : void => {
    addClass('-right-full', menuEl.value as HTMLElement);
    removeClass('right-0', menuEl.value as HTMLElement);
    removeClass('overflow-hidden', document.body);
};

const toggleMenu = (e : Event) : void => {
    if (isContainsClass('menu__bg', e.target as HTMLElement)) {
        hideMenu();
    }
};
</script>

<template>
    <button class="xl:hidden ml-auto" type="button" ref="showMenuBtnEl" @click="showMenu">
        <img :src="asset('image/icons/header/burger-icon.svg')"
             width="30" height="22"
             decoding="async"
             alt="Show mobile menu">
    </button>

    <div class="menu fixed top-0 -right-full bottom-0 xl:static
        w-full h-full transition-left duration-300 ease-out
        xl:ml-11 z-10"
         ref="menuEl">
        <div class="menu__bg h-full bg-black/70" @click="toggleMenu($event)">
            <div class="menu__inner flex flex-col xl:flex-row items-center xl:justify-between
                max-xl:gap-y-5 xl:gap-x-4 max-w-80% xl:max-w-full h-full bg-gray-50 max-xl:py-5
                max-xl:pl-8 max-xl:pr-5 max-xl:ml-auto max-xl:overflow-y-auto">
                <div class="menu__item menu__item--close-btn w-full
                    border-b-2 border-b-orange-200 pb-5 xl:hidden">
                    <button class="block ml-auto" type="button" ref="hideMenuBtnEl" @click="hideMenu">
                        <img :src="asset('image/icons/header/close-icon.svg')"
                             width="21" height="21" decoding="async" loading="lazy"
                             alt="Hide mobile menu">
                    </button>
                </div>

                <div class="menu__item menu__item--main-list flex
                               flex-col xl:flex-row items-end xl:items-center
                               justify-between max-xl:gap-y-5 xl:gap-x-4 w-full
                                max-xl:border-b-2 max-xl:border-b-orange-200 max-xl:pb-5">
                    <a class="menu__link" href="#header">
                        {{ __('header_main') }}
                    </a>

                    <a class="menu__link" href="#services">
                        {{ __('header_services') }}
                    </a>

                    <a class="menu__link" href="#delivery-steps">
                        {{ __('header_delivery') }}
                    </a>

                    <a class="menu__link" href="#about">
                        {{ __('header_about') }}
                    </a>

                    <a class="menu__link" href="#advantages">
                        {{ __('header_advantages') }}
                    </a>

                    <a class="menu__link" href="#reviews">
                        {{ __('header_reviews') }}
                    </a>
                </div>

                <div class="menu__item menu__item--lang-tel-list flex
                            flex-col xl:flex-row items-end
                            xl:items-center shrink-0 max-xl:gap-y-5 xl:gap-x-3 xl:ml-9
                            max-xl:w-full max-xl:border-b-2 max-xl:border-b-orange-200 max-xl:pb-5">
                    <div class="menu__tel">
                        <a :href="'tel:' + props?.tel.replace(/\D+/g, '')">
                            {{ props?.tel }}
                        </a>
                    </div>

                    <div class="menu__lang-list flex gap-x-3 xl:ml-9">
                        <template v-for="(langData, keyName, loopIndex) in props?.language_menu" :key="keyName">
                            <template v-if="langData['is_active']">
                                    <span class="menu__link active text-blue-500">
                                        {{ langData['name'] }}
                                    </span>
                            </template>

                            <template v-else>
                                <a :href="langData['link']" :class="'menu__link'">
                                    {{ langData['name'] }}
                                </a>
                            </template>

                            <template v-if="!isLastLoop(loopIndex, props?.language_menu)">
                                <img :src="asset('image/icons/header/separator-icon.svg')"
                                     width="1" height="8"
                                     decoding="async"
                                     alt="">
                            </template>
                        </template>
                    </div>

                </div>

                <div class="menu__item flex xl:hidden flex-col items-end gap-y-5">
                    <div class="menu__item .menu__item--address text-end">
                        {{ __('header_address') }}
                    </div>

                    <a :href="props?.instagram_link">
                        <img :src="asset('image/icons/header/instagram-icon.svg')"
                             width="40" height="40"
                             decoding="async"
                             alt="Instagram link">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
